import logo from './logo.svg';
import './App.css';
import {BrowserRouter ,Route ,Routes} from "react-router-dom"
import Login from './components/Login';
import MainLayout from './layout/MainLayout';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element = {<MainLayout/>} />
        <Route path='/dashboard' element = {<MainLayout/>} />
        <Route path='/accounts' element = {<MainLayout/>} />
        {/* <Route path='/investment_type' element = {<MainLayout/>} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
